import React from 'react';
import { Card, Page, ResourceList, ResourceItem, Badge } from '@shopify/polaris';

// You can update this roadmap as needed
const ROADMAP = [
  {
    tier: 'Standard',
    features: [
      {
        title: 'Multi-language Support',
        description: 'Allow your chatbot to serve customers in multiple languages. (Coming Soon!)',
        status: 'Upcoming',
      },
      {
        title: 'Chatbot Customization',
        description: 'Customize your chatbot with your own logo, colors, and more. (Coming Soon!)',
        status: 'Upcoming',
      },
    ],
  },
  {
    tier: 'Premium',
    features: [
      {
        title: 'Advanced Analytics Dashboard',
        description: 'Gain deeper insights into customer conversations and engagement. (Planned)',
        status: 'Planned',
      },
      {
        title: 'WhatsApp Integration',
        description: 'Connect your chatbot to WhatsApp for direct customer messaging. (Q3 2025)',
        status: 'Planned',
      }
    ],
  },
];

export default function UpcomingFeatures() {
  return (
    <Page title="What’s New & Upcoming">
      {ROADMAP.map((tier) => (
        <div key={tier.tier} style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>{tier.tier} Tier</div>
          <Card sectioned>
            <ResourceList
              resourceName={{ singular: 'feature', plural: 'features' }}
              items={tier.features}
              renderItem={(item) => (
                <ResourceItem id={item.title}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <span style={{ fontWeight: 600 }}>{item.title}</span>
                    <span
                      style={{
                        display: 'inline-block',
                        background:
                          item.status === 'Upcoming'
                            ? '#e3f0fc'
                            : item.status === 'Planned'
                            ? '#f4e1a1'
                            : item.status === 'Launched'
                            ? '#d4f7d4'
                            : '#eee',
                        color:
                          item.status === 'Upcoming'
                            ? '#1976d2'
                            : item.status === 'Planned'
                            ? '#856404'
                            : item.status === 'Launched'
                            ? '#256029'
                            : '#333',
                        borderRadius: 12,
                        padding: '2px 10px',
                        fontSize: 13,
                        marginLeft: 8,
                        fontWeight: 500,
                      }}
                    >
                      {item.status}
                    </span>
                  </div>
                  <div style={{ color: '#666', marginTop: 4 }}>{item.description}</div>
                </ResourceItem>
              )}
            />
          </Card>
        </div>
      ))}
    </Page>
  );
}
